'use client';
import '../index.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { type PropsWithChildren, Suspense } from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import { Slide, ToastContainer } from 'react-toastify';
import { GoogleTagManager } from '@next/third-parties/google';
import RollbarProvider from '@/providers/RollbarProvider';
import AppProviders from '@/providers/AppProviders';
import ThemeModeProvider from '@/providers/ThemeModeProvider';
import LoadingApp from '@/components/LoadingApp';
import { classes, toastContainerProps } from './utils';

export default function Layout({ children }: PropsWithChildren) {
  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        {/* No-flash: apply the persisted theme class before first paint */}
        <script
          dangerouslySetInnerHTML={{
            __html: `try{if(localStorage.getItem('theme-mode')==='DARK')document.documentElement.classList.add('dark')}catch(e){}`,
          }}
        />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="witMetrics Store" />
        <title>Store | witMetrics</title>
        <link rel="icon" href="/favicon/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicon/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon/favicon-16x16.png"
        />
        <link rel="manifest" href="/favicon/site.webmanifest" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@500;600;700&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <GoogleTagManager gtmId="GTM-TJQLS9ZQ" />
        <RollbarProvider>
          <StyledEngineProvider injectFirst>
            <ThemeModeProvider>
              <Suspense fallback={<LoadingApp />}>
                <AppProviders>
                  <div className={classes.app}>
                    <ToastContainer
                      transition={Slide}
                      {...toastContainerProps}
                    />
                    <div className={classes.content}>{children}</div>
                  </div>
                </AppProviders>
              </Suspense>
            </ThemeModeProvider>
          </StyledEngineProvider>
        </RollbarProvider>
      </body>
    </html>
  );
}
